export default __webpack_public_path__ + "media/images/images_v2/entete4-20f4fa9ecb4c82fc337392edfa0fa2c8.png";